const cssVarToHex = (value: string) => {
  if (value === undefined) {
    return '';
  }
  let hex: string = value;

  if (value.includes('var')) {
    const property = value.substring(
      value.indexOf('(') + 1,
      value.lastIndexOf(')'),
    );
    hex = getComputedStyle(document.documentElement).getPropertyValue(property);
  }
  if (hex.includes('var')) {
    return cssVarToHex(hex);
  }

  return hex;
}

export default cssVarToHex;